import { render } from "./AktuellesPaket.vue?vue&type=template&id=160a465b"
import script from "./AktuellesPaket.vue?vue&type=script&lang=js"
export * from "./AktuellesPaket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__